var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Status servisa eRačuna: "),_c('v-chip',{staticClass:"ma-2",attrs:{"color":_vm.color,"text-color":"white"}},[_vm._v(" "+_vm._s(_vm.serviceStatus)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }